const styles = theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    userSelect: 'none',
    opacity: 0
  },
  item: {
    display: 'block',
    padding: [10, 0],
    height: 24,
    fontSize: 24,
    lineHeight: 1,
    textShadow: `0 0 5px ${theme.color.secondary.main}`,
    textAlign: 'center',
    color: theme.color.text.main,
    transition: 'color 200ms ease-out, text-shadow 200ms ease-out, transform 200ms ease-out',
    '&:hover': {
      color: theme.color.secondary.main,
      textShadow: `0 0 12px ${theme.color.secondary.main}`,
      transform: 'translateY(-2px)'
    }
  }
});

export { styles };

// Commit trace: 2025-12-12T01:19:12 - docs: improve documentation in SocialLinks.styles.js

// Commit trace: 2025-12-25T21:30:02 - feat: enhance functionality of SocialLinks.styles.js
